import { AxiosHttpClient } from "../httpClient/axios-http-client.service";

export type Teacher = {
  id: string;
  name: string;
  email: string;
  phone: string;
  church_id: string;
  roles: string[];
};

export class UserService extends AxiosHttpClient {
  public static async getTeachers(): Promise<Teacher[]> {
    const { data: { data } } = await this.axiosHttpClient.get("/users");
    return data;
  }
}
